import { React, useState, useEffect } from "react";
import { Form, Card, Alert, Button, Dropdown } from "react-bootstrap";
import Error from "./Error";
import Row from "./Row";
import { useDispatch, connect } from "react-redux";
import { changeContentIncludeType, updateUploadModel, loadingFile, loadingModel, showSizeError, showFileTypeError, filesCountError, showWordsCountError } from "../reducers/uploadReducer";
import { updateStepperState, setAnimationClass } from "../reducers/stateManagmentReducer";
import { updateSourceText } from "../actions/translateActions";
import { selectTransUnits, selectUploadModel, selectLanguages, selectMTmodel, selectAnimationClass } from "../reducers/selectors";
import { createStructuredSelector } from "reselect";
import { getTranslationSegments, getFilteredSegments, langDetection } from "../Connector/Connector";
import { resetDetectedLanguage } from "../reducers/languageReducer";
import { FileUploader } from "react-drag-drop-files";
import { ReactComponent as InfoIcon } from "../assets/images/uploadFile/info-icon.svg";
import { FadeLoader } from "react-spinners";
import { checkToken } from "../helpers/tokenHelper";
import ReactGA from "react-ga";

const UploadFile = ({ file, uploadModel, updateStepperState, onUploadClick, onSizeError, onFilesCountError, onTypeError, setAniamtion, animation, onWordsCountError }) => {
  //STATES
  ReactGA.initialize("UA-18031446-1",);
  ReactGA.pageview(window.location.pathname + window.location.search);
  const [show, setShow] = useState(false);
  const [showApply, setShowApply] = useState(false);
  const [translateSettings, setTranslateSettings] = useState({
    showElement: false,
    showRadio: true,
    mesg: "",
    include: false,
    isHtml: true,
  });
  const [className, setClassName] = useState("");
  const [commentText, setCommentText] = useState("");
  const [selectedOption, setSelectedOption] = useState("value1");
  const [contentIncluded, setContentIncluded] = useState("value5");
  const dispatch = useDispatch();

  //Handlers
  const textFieldChangeHandler = (e) => {
    setCommentText(e.target.value);
    setShowApply(true);
  };

  const contentIncludeChangeHandler = (e) => {
    if (e.target.id === "plain-text") {
      setContentIncluded("value4");
      setTranslateSettings({ isHtml: false });
    }
    if (e.target.id === "html-text") {
      setContentIncluded("value5");
    }
    if (e.target.id === "markdown-text") {
      setContentIncluded("value6");
    }
    setShowApply(true);

    const update = {
      containsHTML: e.target.form[6].checked,
      fileId: file.uploadedFile.fileId,
    };
    dispatch(changeContentIncludeType({ type: update }));
  };

  const translationOptionsHandler = (e) => {
    if (e.target.id === "translate-all") {
      setTranslateSettings({ showElement: false });
      setSelectedOption("value1");
      setShowApply(false);
    } else if (e.target.id === "translate-only") {
      setSelectedOption("value2");
      setTranslateSettings({
        ...translateSettings,
        showElement: true,
        msg: `Enter elements you want to translate (for instance ${file.uploadedFile.transUnits[0].filterSpecificNotes} or ${file.uploadedFile.transUnits[1].filterSpecificNotes}).\nSeparate them with commas.`,
        include: true,
      });
    } else if (e.target.id === "do-not-translate") {
      setSelectedOption("value3");
      setTranslateSettings({
        ...translateSettings,
        showElement: true,
        msg: `Enter elements that should not be translated (for instance ${file.uploadedFile.transUnits[0].filterSpecificNotes} or ${file.uploadedFile.transUnits[1].filterSpecificNotes}).\nSeparate them with commas.`,
        include: false,
      });
    }
  };

  const typeErrorHandler = () => {
    onTypeError(true);
    setClassName("animate__fadeInDown");
    setTimeout(() => {
      setClassName("animate__fadeOut");
    }, 8000);
    setTimeout(() => {
      onTypeError(false);
    }, 9000);
  };
  const nextClickHandler = () => {
    let isAnonymous = checkToken(sessionStorage.getItem("token"));
    let wordsCount = 0;
    for (var word = 0; word < file.uploadedFile.transUnits.length; word++) {
      let segment = file.uploadedFile.transUnits[word].segmentText;
      let count = segment.split(" ").length;
      wordsCount += count;
    }
    if (wordsCount > 500 && isAnonymous) {
      onWordsCountError(true);
      setClassName("animate__fadeInDown");
      setTimeout(() => {
        setClassName("animate__fadeOut");
      }, 80000);
      setTimeout(() => {
        onSizeError(false);
      }, 9000);
      return;
    } else {
      setAniamtion("animate__fadeOutLeft");
      setTimeout(() => {
        updateStepperState({ activeStep: 1 });
      }, 500);
      setAniamtion("animate__fadeInRight");
    }

    //updateStepperState({ activeStep: 1 });

    //dispatch(getFilteredSegments(uploadModel.uploadModel));
    //dispatch(getMachineTranslation(modelMT));
  };

  const handleSubmit = (e) => {
    //e.preventDefault();
    //const paragraphSegmentation = e.target[0].checked;
    const include = translateSettings.include; //e.target[6].checked;
    const tags = commentText.replace(/\n/g, " ").split(" ");
    const isHTML = translateSettings.isHtml; //e.target[2].checked;

    uploadModel = {
      fileId: file.uploadedFile.fileId,
      // paragraphSegmentation: paragraphSegmentation,
      tags: tags,
      include: include,
      containsHTML: isHTML,
    };
    dispatch(loadingModel());
    setShowApply(false);
    dispatch(updateUploadModel(uploadModel));
      dispatch(getFilteredSegments(uploadModel));
    window.scrollTo(0, 0);
    //dispatch(updateSourceText(file.uploadedFile.transUnits.map((x) => x.segmentText)));
  };
  const onChangeHandler = (e,) => {
    if (e.length > 1) {
      onFilesCountError(true);
      setClassName("animate__fadeInDown");
      setTimeout(() => {
        setClassName("animate__fadeOut");
      }, 8000);
      setTimeout(() => {
        onFilesCountError(false);
      }, 9000);
      return;
    }

    const fileReader = new FileReader();
    fileReader.readAsText(e[0], "UTF-8");

    try {

      fileReader.onloadend = () => {
        let isAnonymous = checkToken(sessionStorage.getItem("token"));
        // let fileInput = document.querySelector('input[name="uploadjsfile"]');
        let size = e[0].size;
        if (size > 5000 && isAnonymous) {
          onSizeError(true);
          setClassName("animate__fadeInDown");
          setTimeout(() => {
            setClassName("animate__fadeOut");
          }, 80000);
          setTimeout(() => {
            onSizeError(false);
          }, 9000);

          return;
        }
        //local storage
        //localStorage.setItem("userJSON", JSON.stringify(e.target.result));
        onUploadClick();
        dispatch(getTranslationSegments(fileReader.result));
        dispatch(langDetection(fileReader.result));
        setShow(true);
        setShowApply(false);

        ReactGA.event({
          category: "JSON free editor",
          action: "upload file"
        })
      };
    } catch (e) {}
  };

  return (
    <div>
      <div className="upload-file container-md card mt-5">
        <div className="row">
          <div className="col-8">
            <div className="upload-text">
              <h1>
                <span>Upload</span> file
              </h1>
            </div>
          </div>
        </div>
        {file.wordsCountError === true && <Error className={className} text={"Your file contains more than 50 words"}></Error>}
        {file.sizeError === true && <Error className={className} text={"File size cannot exceed 50kB"}></Error>}
        {file.typeError === true && <Error className={className} text={"This is not a JSON file"}></Error>}
        {file.fileCountError === true && <Error className={className} text={"You can upload only one file at a time"}></Error>}
        {file.error === true && file.show === true && <Error className={className} text={"This is not a JSON file"}></Error>}
        {file.show === false && file.sizeError === false && file.typeError === false && file.fileCountError === false && (
          <div>
            {file.isLoading === false ? (
              <>
                <div className="row">
                  <FileUploader
                    classes="drag-n-drop animate__animated animate__fadeIn"
                    types={["json"]}
                    handleChange={(e) => onChangeHandler(e)}
                    name="uploadjsfile"
                    onTypeError={() => typeErrorHandler()}
                    fileOrFiles={[]}
                    multiple={true}
                  />
                </div>
                <div className="row">
                  <div className="info-msg text-center animate__animated animate__fadeInDown">
                    <InfoIcon /> a free translation of JSON files <span>up to 50kB</span>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="row">
                  <div className="loader text-center">
                    <div className="row upload-loading-scrn">
                      <FadeLoader className="align-self-center " height={20} width={7} radius={10} margin={12} color={"#43B4E9"}></FadeLoader>
                      <span className="load-text">Preparing your file...</span>
                    </div>
                  </div>
                  <div className="info-msg text-center">
                    <InfoIcon /> a free translation of JSON files <span>up to 50kB</span>
                  </div>
                </div>
              </>
            )}
          </div>
        )}
        {file.show === true && (
          <div className={`animate__animated ${animation}`}>
            <div className={`segments-section px-2`}>
              {file.uploadedFile.transUnits?.map((row) => (
                <Row row={row} upload={file.uploadedFile.transUnits} rows={file.uploadedFile.transUnits} key={row.id} id={row.id} />
              ))}
            </div>
            <p className="processing-options mt-5">Processing Options</p>
            <div className={`row segments-section px-2 animate__animated ${animation}`}>
              <div className="col-6">
                <div className="card pt-4 ps-4">
                  <fieldset id="group2">
                    <p>Content included</p>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        id="plain-text"
                        type="radio"
                        value="value4"
                        name="group2"
                        checked={contentIncluded === "value4"}
                        onChange={contentIncludeChangeHandler}
                      ></input>
                      <label className="form-check-label" for="group1">
                        Plain text
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        id="html-text"
                        type="radio"
                        value="value5"
                        name="group2"
                        checked={contentIncluded === "value5"}
                        onChange={contentIncludeChangeHandler}
                      ></input>
                      <label className="form-check-label" for="group1">
                        HTML
                      </label>
                    </div>
                    <div className="form-check">
                    </div>
                  </fieldset>
                </div>
              </div>
              <div className="col-6">
                <div className={`card pt-4 ps-4 row segments-section px-2 animate__animated ${animation}`}>
                  <fieldset id="group1">
                    <p>Options</p>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        id="translate-all"
                        type="radio"
                        value="value1"
                        name="group1"
                        checked={selectedOption === "value1"}
                        onChange={translationOptionsHandler}
                      ></input>
                      <label className="form-check-label" for="group1">
                        Translate all
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        id="translate-only"
                        type="radio"
                        value="value2"
                        name="group1"
                        checked={selectedOption === "value2"}
                        onChange={translationOptionsHandler}
                      ></input>
                      <label className="form-check-label" for="group1">
                        Translate only elements
                      </label>
                    </div>

                    <div className="form-check">
                      <input
                        className="form-check-input"
                        id="do-not-translate"
                        type="radio"
                        value="value3"
                        name="group1"
                        checked={selectedOption === "value3"}
                        onChange={translationOptionsHandler}
                      ></input>
                      <label className="form-check-label" for="group1">
                        Do not translate elements
                      </label>
                    </div>
                  </fieldset>
                </div>
              </div>
              <div className="options-text-field row mx-auto mt-3">
                {translateSettings.showElement && (
                  <textarea
                    className={`animate__animated ${translateSettings.showElement ? "animate__fadeInDown" : "animate__fadeOutDown"}`}
                    placeholder={translateSettings.msg}
                    ng-model="myTextarea"
                    required
                    data-error="Please enter customer notes"
                    value={commentText}
                    onChange={textFieldChangeHandler}
                  ></textarea>
                )}
              </div>
            </div>
          </div>
        )}

        {file.show === true && (
          <div className="row text-center mx-auto mt-5">
            {showApply === false ? (
              <Button className="btn-next" disable={!showApply} onClick={() => nextClickHandler()}>
                Next
              </Button>
            ) : (
              <Button className="btn-next" disable={!showApply} onClick={() => handleSubmit()}>
                Apply
              </Button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    langId: (langId) => dispatch(langId(langId)),
    resetDetectedLanguage: () => dispatch(resetDetectedLanguage()),
    updateStepperState: (activeStep) => dispatch(updateStepperState(activeStep)),
    onUploadClick: () => dispatch(loadingFile()),
    onSizeError: (error) => dispatch(showSizeError(error)),
    setAniamtion: (animation) => dispatch(setAnimationClass(animation)),
    onTypeError: (error) => dispatch(showFileTypeError(error)),
    onFilesCountError: (error) => dispatch(filesCountError(error)),
    onWordsCountError: (error) => dispatch(showWordsCountError(error)),
  };
};
const mapStateToProps = createStructuredSelector({
  file: selectTransUnits,
  uploadModel: selectUploadModel,
  languages: selectLanguages,
  modelMT: selectMTmodel,
  animation: selectAnimationClass,
});
export default connect(mapStateToProps, mapDispatchToProps)(UploadFile);
